export class User {
    constructor(public MedewerkerID: number, 
        public CplNaam: string, 
        public VoorNaam: string, 
        public AchterNaam: string, 
        public Email: string, 
        public AfdID: number, 
        public Afdeling: string, 
        public Token: string,
        public BedrijfID: number){}
  }


